module.exports = __webpack_public_path__ + "static/media/credit_card_img.f5f2dcfa.svg";